/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Store } from "store";
import { useI18n } from "hooks/i18n/i18n";
import { liveActions } from "modules/live";
import { firestoreActions } from "modules/firestore";
import { getLiveContextType } from "utility/live";
import { StreamingLiveEventQuizV2 } from "./StreamingLiveEventQuizV2";
import { Box } from "@material-ui/core";
import { VoteIcon } from "./VoteIcon";

export const StreamingLiveEventV2: FC = () => {
  const { t } = useI18n();
  const dispatch = useDispatch();

  // @ts-expect-error TS2345
  const [eventId, setEventId] = useState<string>(null);

  const isDarkModeEnabled = useSelector(
    (state: Store) => state.streaming.streamingSettings.isDarkModeEnabled
  );
  const contextId = useSelector((state: Store) => state.live.contextId);
  const eventInfo = useSelector((state: Store) => state.event.displayEvent);

  const watchEventInfo = () => {
    const eventId = eventInfo._id;
    dispatch(liveActions.watchEventContext.started({ eventId }));
    // @ts-expect-error TS2345
    setEventId(eventId);
    return () => {
      dispatch(firestoreActions.closeChannel({ channel: "liveContext" }));
    };
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(watchEventInfo, [eventInfo]);

  if (!eventId || contextId === null) {
    return null;
  }

  const contextType = getLiveContextType(contextId);
  switch (contextType) {
    case "qid":
      return (
        <StreamingLiveEventLayout isDarkModeEnabled={isDarkModeEnabled}>
          <StreamingLiveEventQuizV2 eventId={eventId} />
        </StreamingLiveEventLayout>
      );
    case "cid":
      return (
        /**
         * TODO@Kawano
         * 今現在スタイルは無し
         * Tap Eventを使うことになったらスタイルを作成する
         *
         **/
        <StreamingLiveEventLayout isDarkModeEnabled={isDarkModeEnabled}>
          <Box fontSize={"14px"}>
            {t("streaming.commerceLiveEvent.eventTap")}
          </Box>
        </StreamingLiveEventLayout>
      );
    default:
      return (
        <StreamingLiveEventLayout isDarkModeEnabled={isDarkModeEnabled}>
          <Box fontSize={"14px"}>
            {t("streaming.commerceLiveEvent.loadingEvent")}
          </Box>
        </StreamingLiveEventLayout>
      );
  }
};

const StreamingLiveEventLayout: FC<{
  children: React.ReactNode;
  isDarkModeEnabled: boolean;
}> = ({ children, isDarkModeEnabled }) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gridGap={"6px"}
      color={isDarkModeEnabled ? "#fff" : "#000"}
    >
      <Box
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        gridGap={"8px"}
      >
        <VoteIcon
          style={{
            width: "14px",
            height: "auto",
          }}
        />
        <Box paddingTop={"2px"} fontSize={"14px"} fontWeight={"bold"}>
          投票
        </Box>
      </Box>

      {children}
    </Box>
  );
};
